import React, { useEffect, useRef, useState } from 'react'
import { Button, Checkbox, Col, Divider, Form, Input, message, Row, Select } from 'antd'
import { CloseIcon, FormBody, FormHeader, RegisterFormWrapper, RegisterTitle } from './RegisterFormStyled'
import IMAGES from '../../images'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { useNavigate } from 'react-router-dom'
import { PAGES, STATION_TYPE, VIEW_MODE } from '../../constant'
import { useRecoilValue, useResetRecoilState } from 'recoil'
import { districtState, provinceState, wardsState } from '../../recoil/landingPageState'
import landingPageStore from '../../stores/landingPageStore'
import validator from '../../validator'
import stringUtils from '../../utils/stringUtils'
import PropTypes from 'prop-types'
import ReCaptcha from '../../components/ReCaptcha/ReCaptcha'

const RegisterForm = props => {
  const { stationType, pageConfig, mode } = props
  const recaptchaRef = useRef(null)
  const navigate = useNavigate()

  const [formStep] = Form.useForm()

  const listProvince = useRecoilValue(provinceState)
  const listDistrict = useRecoilValue(districtState)
  const listWard = useRecoilValue(wardsState)

  const resetProvince = useResetRecoilState(provinceState)
  const resetDistrict = useResetRecoilState(districtState)
  const resetWard = useResetRecoilState(wardsState)

  const [disabledButton, setDisabledButton] = useState(false)
  const [existBusinessNumber, setExistBusinessNumber] = useState('')
  const [products, setProducts] = useState([])

  const handleSubmit = async e => {
    if (mode === VIEW_MODE.PREVIEW) {
      message.info('Chế độ xem trước không cho phép gửi thông tin')
      return
    }

    const token = await recaptchaRef.current.execute()
    // console.log(token)
    if (!token) {
      message.error('Lỗi reCaptcha')
      return
    }
    let payload = {
      businessName: e.businessName,
      district: listDistrict?.find(item => item.districtId === e.districtId)?.description,
      email: e.email,
      nameOfRepresentative: e.nameOfRepresentative,
      phoneNumber: e.phoneNumber,
      product: e.product.join(';'),
      province: listProvince?.find(item => item.provinceId === e.provinceId)?.description,
      stationType: stationType,
      taxCode: e.taxCode,
      ward: listWard?.find(item => item.wardId === e.wardId)?.description,
      token: token,
    }
    setDisabledButton(true)
    landingPageStore
      .registerProduct(payload)
      .then(res => {
        if (res.statusCode == 200) {
          navigate(PAGES.REGISTER_SUCCESS.PATH)
        } else {
          message.error(res.message)
        }
      })
      .catch(error => {
        message.error(error.message)
      })
      .finally(() => setDisabledButton(false))
  }

  useEffect(() => {
    if (!pageConfig) return
    let productByStationType = []
    switch (stationType) {
      case STATION_TYPE.BUSINESS:
        productByStationType = pageConfig?.businessStationConfig?.products
        break
      case STATION_TYPE.KNOWLEDGE:
        productByStationType = pageConfig?.knowledgeStationConfig?.products
        break
      case STATION_TYPE.FINANCE:
        productByStationType = pageConfig?.financialStationConfig?.products
        break
      case STATION_TYPE.ECOMMERCE:
        productByStationType = pageConfig?.ecommerceStationConfig?.products
        break
      default:
        break
    }
    setProducts(productByStationType)
  }, [pageConfig])

  const handleClickClose = () => {
    switch (mode) {
      case VIEW_MODE.PREVIEW:
        navigate(PAGES.PREVIEW.PATH)
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth',
        })
        break
      case VIEW_MODE.PUBLIC:
        navigate(PAGES.HOME.PATH)
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth',
        })
        break
      default:
        break
    }
  }

  const handleChangeProvince = e => {
    if (!e) {
      resetDistrict()
      resetWard()
      return
    }
    resetWard()
    formStep.setFieldsValue({
      districtId: null,
      wardId: null,
    })
    landingPageStore.getDistrict(e)
  }
  const handleChangeDistrict = e => {
    if (!e) {
      resetWard()
      return
    }
    formStep.setFieldsValue({
      wardId: null,
    })
    landingPageStore.getWard(e)
  }

  useEffect(() => {
    landingPageStore.getProvince()
    let payload = {
      channel: 'STATION',
      campaign: 'DIGITAL',
    }
  }, [])

  useEffect(() => {
    return () => {
      resetProvince()
      resetDistrict()
      resetWard()
    }
  }, [])

  return (
    <>
      <ReCaptcha
        onVerify={token => {
          // console.log('Token verified:', token)
        }} // Nếu muốn xử lý thêm token ở đây
        ref={recaptchaRef}
      />
      <RegisterFormWrapper>
        <FormHeader>
          <img src={IMAGES.WHITE_LOGO} className={'register-logo'} />
        </FormHeader>
        <FormBody>
          <RegisterTitle>
            <span>THÔNG TIN ĐĂNG KÝ</span>
            <CloseIcon onClick={handleClickClose}>
              <FontAwesomeIcon color={'#E10600'} size={'2x'} icon={faTimes} />
            </CloseIcon>
          </RegisterTitle>
          <Form onFinish={handleSubmit} colon={false} size={'large'} layout={'vertical'} form={formStep}>
            <Row gutter={[24, 0]}>
              {!existBusinessNumber && (
                <>
                  <Col className={'form-item-wrapper'} xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                    <label htmlFor={'businessName'}>Tên doanh nghiệp</label>
                    <Form.Item
                      rules={[{ validator: validator.validateCompanyName }]}
                      label={'Tên doanh nghiệp'}
                      name={'businessName'}
                    >
                      <Input placeholder={'Nhập tên doanh nghiệp'} autoComplete={'off'} />
                    </Form.Item>
                  </Col>
                  <Col className={'form-item-wrapper'} xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                    <label htmlFor={'taxCode'}>Mã số thuế</label>
                    <Form.Item rules={[{ validator: validator.validateTaxCode }]} label={'Mã số thuế'} name={'taxCode'}>
                      <Input placeholder={'Nhập mã số thuế'} autoComplete={'off'} />
                    </Form.Item>
                  </Col>
                  <Col className={'form-item-wrapper'} xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                    <label htmlFor={'nameOfRepresentative'}>Tên người đại diện</label>
                    <Form.Item
                      rules={[{ validator: validator.validateLegalFullName }]}
                      label={'Tên người đại diện'}
                      name={'nameOfRepresentative'}
                    >
                      <Input placeholder={'Nhập tên người liên hệ'} autoComplete={'off'} />
                    </Form.Item>
                  </Col>
                  <Col className={'form-item-wrapper'} xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                    <label htmlFor={'email'}>Email</label>
                    <Form.Item rules={[{ validator: validator.validateEmail }]} label={'Email'} name={'email'}>
                      <Input placeholder={'Nhập email người liên hệ'} autoComplete={'off'} />
                    </Form.Item>
                  </Col>
                  <Col className={'form-item-wrapper'} xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                    <label htmlFor={'phoneNumber'}>Số điện thoại</label>
                    <Form.Item
                      rules={[{ validator: validator.validatePhoneNumber }]}
                      label={'Số điện thoại'}
                      name={'phoneNumber'}
                    >
                      <Input placeholder={'Nhập số điện thoại'} autoComplete={'off'} />
                    </Form.Item>
                  </Col>
                  <Col className={'form-item-wrapper'} xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
                    <label htmlFor={'provinceId'}>Tỉnh/Thành phố</label>
                    <Form.Item
                      rules={[{ validator: validator.validateProvince }]}
                      label={'Tỉnh/Thành phố'}
                      name={'provinceId'}
                    >
                      <Select
                        showSearch
                        onChange={handleChangeProvince}
                        optionFilterProp={'name'}
                        style={{ width: '100%' }}
                        placeholder={'Chọn Tỉnh/Thành phố'}
                      >
                        {listProvince &&
                          listProvince.map(item => (
                            <Select.Option
                              key={item.provinceId}
                              name={`${item.description} ${stringUtils.removeVietnameseCharMark(item.description)}`}
                              value={item.provinceId}
                            >
                              {item.description}
                            </Select.Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col className={'form-item-wrapper'} xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
                    <label htmlFor={'districtId'}>Quận/Huyện</label>
                    <Form.Item
                      rules={[{ validator: validator.validateDistrict }]}
                      label={'Quận/Huyện'}
                      name={'districtId'}
                    >
                      <Select
                        showSearch
                        onChange={handleChangeDistrict}
                        optionFilterProp={'name'}
                        style={{ width: '100%' }}
                        placeholder={'Chọn Quận/Huyện'}
                      >
                        {listDistrict &&
                          listDistrict.map(item => (
                            <Select.Option
                              key={item.districtId}
                              name={`${item.description} ${stringUtils.removeVietnameseCharMark(item.description)}`}
                              value={item.districtId}
                            >
                              {item.description}
                            </Select.Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col className={'form-item-wrapper'} xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
                    <label htmlFor={'wardId'}>Phường/Xã</label>
                    <Form.Item rules={[{ validator: validator.validateWards }]} label={'Phường/Xã'} name={'wardId'}>
                      <Select
                        showSearch
                        optionFilterProp={'name'}
                        style={{ width: '100%' }}
                        placeholder={'Chọn Phường/Xã'}
                      >
                        {listWard &&
                          listWard.map(item => (
                            <Select.Option
                              key={item.wardId}
                              name={`${item.description} ${stringUtils.removeVietnameseCharMark(item.description)}`}
                              value={item.wardId}
                            >
                              {item.description}
                            </Select.Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </>
              )}

              {/*<Col className={'form-item-wrapper'} xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>*/}
              {/*  <label htmlFor={'activitiesTime'}>Số năm hoạt động</label>*/}
              {/*  <Form.Item*/}
              {/*    rules={[{ validator: validator.validateActivitiesTime }]}*/}
              {/*    label={'Số năm hoạt động'} name={'activitiesTime'}>*/}
              {/*    <Select style={{ width: '100%' }} placeholder={'Chọn'}>*/}
              {/*      <Select.Option value={1}>1-2 năm</Select.Option>*/}
              {/*      <Select.Option value={2}>3-5 năm</Select.Option>*/}
              {/*      <Select.Option value={3}>Trên 5 năm</Select.Option>*/}
              {/*    </Select>*/}
              {/*  </Form.Item>*/}
              {/*</Col>*/}
              {/*<Col className={'form-item-wrapper'} xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>*/}
              {/*  <label htmlFor={'recentRevenue'}>Doanh thu gần nhất</label>*/}
              {/*  <Form.Item*/}
              {/*    rules={[{ validator: validator.validateRecentRevenue }]}*/}
              {/*    label={'Doanh thu gần nhất'} name={'recentRevenue'}>*/}
              {/*    <Select style={{ width: '100%' }} placeholder={'Chọn'}>*/}
              {/*      <Select.Option value={1}>Dưới 2 tỷ</Select.Option>*/}
              {/*      <Select.Option value={2}>Từ 2 tỷ trở lên</Select.Option>*/}
              {/*    </Select>*/}
              {/*  </Form.Item>*/}
              {/*</Col>*/}
              <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                <span className={'solutions-label'}>Dịch vụ quan tâm</span>
                <Form.Item
                  rules={[{ validator: validator.validateCareSolutions }]}
                  name={'product'}
                  valuePropName={'checked'}
                >
                  <Checkbox.Group style={{ width: '100%' }}>
                    <Row style={{ width: '100%' }} justify={'space-between'} gutter={[8, 8]}>
                      {products?.length > 0 &&
                        products.map(item => (
                          <Col key={item} xxl={6} xl={6} lg={6} md={8} sm={24} xs={24}>
                            <Checkbox value={item}>{item}</Checkbox>
                          </Col>
                        ))}
                    </Row>
                  </Checkbox.Group>
                </Form.Item>
              </Col>
              <Col className={'form-item-wrapper'} xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                <Divider dashed style={{ borderColor: 'green', margin: '0 0 16px 0' }} />
              </Col>
              <Col className={''} xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                <Form.Item
                  rules={[{ validator: validator.validateConfirm }]}
                  name={'confirm'}
                  valuePropName={'checked'}
                >
                  <Checkbox>
                    Bằng việc đăng ký thông tin này, tôi đồng ý nhận các thông báo liên quan từ VPBank
                  </Checkbox>
                </Form.Item>
              </Col>
              <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                <Form.Item>
                  <Button
                    disabled={disabledButton}
                    style={{ marginTop: 16 }}
                    className={'gradient-btn'}
                    type={'primary'}
                    htmlType={'submit'}
                    block
                  >
                    Gửi thông tin
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </FormBody>
      </RegisterFormWrapper>
    </>
  )
}

RegisterForm.propTypes = {
  stationType: PropTypes.string,
  pageConfig: PropTypes.object,
  mode: PropTypes.string,
}

export default RegisterForm
